import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import GuideLayout from './pages/guide/GuideLayout';
import PrinciplePremiumPage from './pages/guide/PrinciplePremiumPage';
import PrincipleAllInOnePage from './pages/guide/PrincipleAllInOnePage';
import PrincipleProfitPage from './pages/guide/PrincipleProfitPage';
import ProcessGuidePage from './pages/guide/ProcessGuidePage';
import CreativeGuidePage from './pages/guide/CreativeGuidePage';
import ProductGuidePage from './pages/guide/ProductGuidePage';
import PropertyGuidePage from './pages/guide/PropertyGuidePage';
import PlacementsGuidePage from './pages/guide/PlacementsGuidePage';
import PrinciplesPage from "./pages/PrinciplesPage";
import CfContentPage from "./pages/guide/CfContentPage";
import BannerContentPage from "./pages/guide/BannerContentPage";
import FaqPage from "./pages/guide/FaqPage";

function App() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Routes>
        <Route path="/" element={<Navigate to="/guide/principles/index" replace />} />
        <Route path="/guide" element={<GuideLayout />}>
          <Route path="principles/index" element={<PrinciplesPage />}/>
          <Route path="principles/premium" element={<PrinciplePremiumPage />} />
          <Route path="principles/all-in-one" element={<PrincipleAllInOnePage />} />
          <Route path="principles/profit" element={<PrincipleProfitPage />} />
          <Route path="process" element={<ProcessGuidePage />} />
          <Route path="creative" element={<CreativeGuidePage />} />
          <Route path="content/banner" element={<BannerContentPage />} />
          <Route path="content/cf" element={<CfContentPage />} />
          <Route path="product" element={<ProductGuidePage />} />
          <Route path="property" element={<PropertyGuidePage />} />
          <Route path="placements" element={<PlacementsGuidePage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route index element={<Navigate to="principles/index" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/guide/principles/index" replace />} />
      </Routes>
    </div>
  );
}

export default App;
